import cn from 'classnames';
import { useCallback } from 'react';
import { DropdownItem, useMenuDropdown } from '@shared/ui/index.ts';
import { DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu/index.ts';
import { useAddAuthorToFavoriteMutation } from '@src/api/api-hooks/users/useAddAuthorToFavoriteMutation.ts';
import { useRemoveAuthorFromFavoriteMutation } from '@src/api/api-hooks/users/useRemoveAuthorFromFavoriteMutation.ts';
import * as st from './styles.module.scss';

type PT = {
  authorId: number;
  isFavorite: boolean;
  needDropDawnShowUp: boolean;
};

export const AuthorsListDropdownMenu = (props: PT) => {
  const { needDropDawnShowUp, authorId, isFavorite } = props;
  const { menuRef, onClose, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});
  const { mutateAsync: addAuthorToFavorite, isPending: isAddPending } =
    useAddAuthorToFavoriteMutation();
  const { mutateAsync: removeAuthorFromFavorite, isPending: isRemovePending } =
    useRemoveAuthorFromFavoriteMutation();
  const changeAuthorFavoriteStatus = useCallback(async () => {
    if (isFavorite) {
      await removeAuthorFromFavorite({ id: authorId });
    } else {
      await addAuthorToFavorite({ id: authorId });
    }
    onClose();
  }, [removeAuthorFromFavorite, addAuthorToFavorite, isFavorite, authorId, onClose]);
  const isPending = isAddPending || isRemovePending;
  return (
    <DropdownMenuWithButton
      smallButton={true}
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
      dropDownClassName={cn(needDropDawnShowUp ? st.lastMenu : undefined)}
      mouseLeaveAreaClassName={cn(needDropDawnShowUp ? st.mouseLeaveArea : undefined)}
    >
      <DropdownItem disabled={isPending} onClick={changeAuthorFavoriteStatus}>
        {isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      </DropdownItem>
    </DropdownMenuWithButton>
  );
};
